import React, { useMemo } from 'react';
import LclKanbanColumn from './LclKanbanColumn';
import LclOperationCard from '../LclOperationCard';

/**
 * Columna "Cotizaciones" — agrupa solicitudes LCL en estado `Borrador`.
 *
 * Archivo independiente para poder ajustar esta columna sin tocar
 * las otras tres ni nada del módulo aéreo.
 */
const LclCotizacionesColumn = ({
  items = [],
  onAction,
  loading = false,
  headerExtra,
  actionsMode = 'full',
}) => {
  // `renderItem` se memoriza para no recrearlo en cada render del padre
  const renderItem = useMemo(
    () => (r) => (
      <LclOperationCard
        r={r}
        variant="cotizaciones"
        onAction={onAction}
        actionsMode={actionsMode}
      />
    ),
    [onAction, actionsMode],
  );

  return (
    <LclKanbanColumn
      id="cotizaciones"
      title="Cotizaciones"
      accent="border-t-amber-400"
      badge="bg-amber-100 text-amber-800 border-amber-200"
      items={items}
      renderItem={renderItem}
      loading={loading}
      emptyText="Sin cotizaciones en borrador"
      headerExtra={headerExtra}
    />
  );
};

export default LclCotizacionesColumn;
